import { useScopedRequests } from "../../../../shared/useScopedRequests";
import React, { createContext, useContext, useState, useCallback, useEffect, useMemo } from "react";
import services from "../services/indexService";
import useToast from "../hooks/useToast";
import { formatToYyyyMmDd } from "../../utils/formats";
import AlertPopup from "../components/index/AlertPopup";
import { appInsights, trackEvent, trackError } from "../../telemetry/telemetryService";

export const taskPaneInitailValue = {
  // Index
  docDescription: "",
  documentClass: "",
  documentType: "",
  receivedDate: "",
  chkQuoteSentToProducer: false,
  useFileName: false,
  docNotes: "",
  // task
  taskChecked: false,
  taskSubject: "",
  sameAsDocDesc: false,
  taskQueue: "",
  taskType: "",
  taskNote: "",
  taskDueDate: "",
  taskStartDate: "",
  taskPriority: "",
  checklistItem: "",
};
const TaskPaneContext = createContext({
  selectedGridItem: [],
  selectedItemDetailFromGrid: null,
  setSelectedGridItem: (_selectedItems) => {},
  queues: [],
  setQueues: (_queues = []) => {},
  userGroups: [],
  setUserGroups: (_values = []) => {},
  user: [],
  setUsers: (_values = []) => {},
  taskTypes: [],
  setTaskTypes: (_values = []) => {},
  taskPaneState: {
    searchText: null,
    compId: null,
    comLocId: null,
    criteria: null,
    insuredId: null,
    userId: null,
    userGroupId: null,
    taskTypeId: null,
  },
  accessToken: null,
});

export const TaskPaneProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [taskPaneState, setTaskPaneState] = useState({
    searchText: null,
    compId: null,
    comLocId: null,
    criteria: null,
    insuredId: null,
    userId: null,
    userGroupId: null,
  });
  //
  const [accessToken, setAccessToken] = useState(null);
  const isDialog = new URLSearchParams(window.location.search).get("dialog") === "true";
  //
  const { notify, Toaster } = useToast();
  const [profileDetails, setProfileDetails] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [policiesDetailsForInsured, setPoliciesDetailsForInsured] = useState([]);
  const [selectedGridItem, setSelectedGridItem] = useState([]);
  const [documentType, setDocumentType] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const [documentClass, setDocumentClass] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [queues, setQueues] = useState([]);
  const [user, setUsers] = useState([]);
  const [taskTypes, setTaskTypes] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const [open, setOpen] = useState(false);
  const selectedPolicyId = [...selectedGridItem][0] || "";
  const baseScope = [taskPaneState.userId, taskPaneState.compId, taskPaneState.comLocId];
  const requests = useScopedRequests({
    location: baseScope,
    types: baseScope,
    groups: [taskPaneState.userId],
    classes: [...baseScope, taskPaneState.criteria],
    policies: [...baseScope, taskPaneState.criteria, taskPaneState.insuredId],
    details: [...baseScope, taskPaneState.criteria, selectedPolicyId, taskPaneState.documentType],
    checklist: [...baseScope, selectedPolicyId],
    queues: [...baseScope, taskPaneState.userGroupId],
    users: [...baseScope, taskPaneState.userGroupId],
    tasks: [...baseScope, taskPaneState.userGroupId],
    locations: [taskPaneState.userId],
    emailLocation: baseScope,
  });
  const metadataLoading = requests.pending;

  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const getPoliciesDetailsForInsuredData = async (
    InsuredID,
    SubmissionStatusID,
    LoggedInCompLocID,
    ViewAllCompLocs,
  ) => {
    const operation = requests.start("policies");
    try {
      setPoliciesDetailsForInsured([]);
      setSelectedGridItem([]);
      setTaskPaneState((prev) => ({ ...prev }));
      try {
        const result = await services.getPoliciesDetailsForInsured(
          InsuredID,
          SubmissionStatusID,
          LoggedInCompLocID,
          ViewAllCompLocs,
          taskPaneState?.userId,
        );
        if (!requests.current(operation)) return;
        if (!!result && result?.length) {
          setSelectedGridItem(
            result?.length
              ? new Set([taskPaneState?.isEmailSub ? taskPaneState?.policyId : result[0]?.policyID])
              : [],
          );
          setPoliciesDetailsForInsured(result);
          setTaskPaneState((prev) => ({ ...prev, isEmailSub: false }));
          return result;
        } else {
          setTitle("Search result");
          setText("No policy details found");
          // setOpen(true);
        }
      } catch (e) {
        if (!requests.current(operation)) return;
        console.log("policy list", e);
        if (e?.response?.status === 403) {
          setTitle(e?.response?.data?.error === "AccessDenied" ? "Access Denied" : "Search Failed");
          setText(e?.response?.data?.message);
          // setOpen(true);
        }
        setTaskPaneState((prev) => ({ ...prev }));
        setPoliciesDetailsForInsured([]);
        setSelectedGridItem([]);
      }
    } finally {
      requests.finish(operation);
    }
  };
  useEffect(() => {
    if (taskPaneState.comLocId) getPriorityList();
  }, [taskPaneState.comLocId]);

  const getPriorityList = async () => {
    try {
      const result = await services.getPriorityList();
      setPriorityList(result);
    } catch (e) {
      setPriorityList([]);
      console.log(e);
    }
  };
  const filterTypeByCriteriaType = useMemo(
    () =>
      taskPaneState?.criteria === "Insured" ||
      taskPaneState?.criteria === "Policy #" ||
      taskPaneState?.criteria === "Submission #"
        ? "Type Insured/Policy"
        : taskPaneState?.criteria === "Producer #" || taskPaneState?.criteria === "Producer Name"
          ? "Type Producer"
          : "Type claim",
    [taskPaneState?.criteria],
  );

  useEffect(() => {
    if (!taskPaneState.comLocId) {
      setPoliciesDetailsForInsured([]);
      setSelectedGridItem([]);
      setDocumentType([]);
      setDocumentClass([]);
      setCheckList([]);
    }
  }, [taskPaneState.comLocId]);
  const selectedItemDetailFromGrid = useMemo(() => {
    if (filterTypeByCriteriaType === "Type Insured/Policy" && policiesDetailsForInsured) {
      const selectedPolicy = policiesDetailsForInsured?.find(
        (item) => item.policyID === [...selectedGridItem][0],
      );
      setTaskPaneState((prev) => ({
        ...prev,
        // receivedDate: formatToYyyyMmDd(selectedPolicy?.receiveDate),
        chkQuoteSentToProducer: !!selectedPolicy?.chkQuoteSentToProducer ?? false,
        unlockchkQuoteSentToProducer: !!selectedPolicy?.unlockchkQuoteSentToProducer ?? false,
        policychkQuoteSentToProducer: !!selectedPolicy?.policychkQuoteSentToProducer ?? false,
        //docDescription: selectedPolicy?.docDescription?.length ? selectedPolicy.docDescription.substring(0, 60) : "",
        //documentType: selectedPolicy?.documentType ?? "",
        // useFileName: !!selectedPolicy?.useFileName ?? false,
        //documentClass: selectedPolicy?.documentClass ?? "",
        // emailSubject: selectedPolicy?.emailSubject ?? "",
        docNotes: selectedPolicy?.docNotes?.length ? selectedPolicy?.docNotes.substring(0, 255) : "",

        useChecklistItem: false,
        docDescription: prev?.useChecklistItem ? "" : prev?.docDescription,
        sameAsDocDesc: !!prev?.useChecklistItem && !!prev?.sameAsDocDesc ? false : !!prev?.sameAsDocDesc,
        taskSubject: !!prev?.useChecklistItem && !!prev?.sameAsDocDesc ? "" : prev?.taskSubject,
      }));
      return selectedPolicy;
    } else {
      const selectedProducer = policiesDetailsForInsured?.find(
        (item) => item.producerId === [...selectedGridItem][0],
      );
      return {
        ProducerID: selectedProducer?.producerId,
        policyNumber: "",
        lob: "",
      };
    }
  }, [selectedGridItem, policiesDetailsForInsured, filterTypeByCriteriaType]);

  useEffect(() => {
    if (
      selectedItemDetailFromGrid?.policyID &&
      taskPaneState.comLocId &&
      taskPaneState.userId &&
      taskPaneState.documentType
    ) {
      getIndexFormDetails(
        taskPaneState?.documentType,
        taskPaneState.comLocId,
        !!localStorage.getItem("actionType"),
        selectedItemDetailFromGrid?.policyID,
        null,
        taskPaneState.userId,
        taskPaneState.emailSubject,
      );
    } else {
      if (!selectedItemDetailFromGrid?.ProducerID && !selectedItemDetailFromGrid?.policyID) {
        setTaskPaneState((prev) => ({
          ...prev,
          ...taskPaneInitailValue,
          userGroupId: prev?.profileUserGroupId,
          userGroup: prev?.userId,
        }));
      }
    }
  }, [taskPaneState?.documentType, selectedItemDetailFromGrid?.policyID]);

  const getIndexFormDetails = async (
    imgKeywordId,
    CompLocID,
    EmailIndex,
    policyID,
    policyDetailId,
    userId,
    txtSubject,
  ) => {
    const operation = requests.start("details");
    setTaskPaneState((prev) => ({ ...prev, documentClass: "" }));
    try {
      //notify("progress");
      const result = await services.GetIdsByImageKeywordSelect(
        imgKeywordId,
        CompLocID,
        EmailIndex && !!txtSubject,
        policyID,
        policyDetailId,
        userId,
        txtSubject,
      );
      if (!requests.current(operation)) return;
      setTaskPaneState((prev) => ({
        ...prev,
        docDescription: result?.docDescription?.length ? result?.docDescription.substring(0, 60) : "",
        documentClass: result?.documentClassID ?? "",
        // documentType: result?.imgKeywordID ?? "",
        // receivedDate: formatToYyyyMmDd(result?.receiveDate),
        // chkQuoteSentToProducer: result?.chkQuoteSentToProducer ?? false,
        useFileName: result?.docDescription?.length ? false : prev?.useFileName,
        useChecklistItem: result?.docDescription?.length ? false : prev?.useChecklistItem,
        emailSubject: result?.subject ? result?.subject : taskPaneState?.emailSubject,
        // docNotes: result?.docNotes ?? "",
        // task
        taskChecked: result?.chkTask,
        taskSubject: result?.txtSubject?.length ? result?.txtSubject.substring(0, 60) : "",
        sameAsDocDesc:
          result?.docDescription?.length || result?.txtSubject?.length ? false : prev?.sameAsDocDesc,
        userGroupId: result?.userGroupID ? result?.userGroupID : taskPaneState?.profileUserGroupId,
        userGroup: result?.assignedId ? result?.assignedId : taskPaneState?.userId,
        taskQueue: result?.imgCommonQueueID,
        taskType: result?.taskTypeID,
        // taskNote: result?.docNotes?? "",
        taskDueDate: result?.dueDateOnly,
        taskStartDate: result?.startDateOnly,
        taskPriority: result?.priorityID,
      }));
    } catch (e) {
      if (!requests.current(operation)) return;
      //notify("error", "Failed to fetch GetIdsByImageKeywordSelect data");
      console.log(e);
    } finally {
      requests.finish(operation);
    }
  };
  const getDocumentType = async (comLocId) => {
    const operation = requests.start("types");
    try {
      const result = await services.getDocumentType(comLocId);
      if (!requests.current(operation)) return;
      setDocumentType(result);
    } catch (e) {
      if (!requests.current(operation)) return;
      setDocumentType([]);
      console.log(e);
    } finally {
      requests.finish(operation);
    }
  };

  const getDocumentClass = async (comLocId, criteria) => {
    const operation = requests.start("classes");
    try {
      const result = await services.getDocumentClass(criteria, comLocId, false);
      if (!requests.current(operation)) return;
      setDocumentClass(result);
    } catch (e) {
      if (!requests.current(operation)) return;
      setDocumentClass([]);
      console.log(e);
    } finally {
      requests.finish(operation);
    }
  };

  const getUserGroupsForPerson = async (userId) => {
    const operation = requests.start("groups");
    try {
      const result = await services.getUserGroupsForPerson(userId);
      if (!requests.current(operation)) return;
      setUserGroups(result);
      setTaskPaneState((prev) => ({ ...prev }));
    } catch (e) {
      if (!requests.current(operation)) return;
      console.log(e);
      setUserGroups([]);
    } finally {
      requests.finish(operation);
    }
  };
  const getQueuesForUserGroup = async (userGroupId) => {
    const operation = requests.start("queues");
    try {
      const result = await services.getQueuesForUserGroup(userGroupId);
      if (!requests.current(operation)) return;
      setQueues(result);
      setTaskPaneState((prev) => ({ ...prev }));
    } catch (e) {
      if (!requests.current(operation)) return;
      console.log(e);
      setQueues([]);
    } finally {
      requests.finish(operation);
    }
  };

  const getPersonUserGroupXRef = async (userGroupId, activeOnly, activeAndExpiredWithOpenTask) => {
    const operation = requests.start("users");
    try {
      const result = await services.getPersonUserGroupXRef(
        userGroupId,
        activeOnly,
        activeAndExpiredWithOpenTask,
      );
      if (!requests.current(operation)) return;
      setUsers(result);
      setTaskPaneState((prev) => ({ ...prev }));
    } catch (e) {
      if (!requests.current(operation)) return;
      setUsers([]);
      console.log(e);
    } finally {
      requests.finish(operation);
    }
  };
  const getCheckList = async (PolicyId, Completed, CompLocID, IncludeNone) => {
    const operation = requests.start("checklist");
    try {
      setTaskPaneState((prev) => ({ ...prev, checklistItem: "" }));
      const result = await services.getPolicyChecklistForPolicy(PolicyId, Completed, CompLocID, IncludeNone);
      if (!requests.current(operation)) return;
      setCheckList(result);
    } catch (e) {
      if (!requests.current(operation)) return;
      setCheckList([]);
      setTaskPaneState((prev) => ({ ...prev, checklistItem: "" }));
    } finally {
      requests.finish(operation);
    }
  };
  const getTaskTypes = async (userGroupId) => {
    const operation = requests.start("tasks");
    try {
      const result = await services.getTaskTypes(0, userGroupId);
      if (!requests.current(operation)) return;
      setTaskTypes(result);
    } catch (e) {
      if (!requests.current(operation)) return;
      setTaskTypes([]);
    } finally {
      requests.finish(operation);
    }
  };
  useEffect(() => {
    if (taskPaneState.comLocId) {
      getDocumentType(taskPaneState.comLocId);
    }
  }, [taskPaneState.comLocId]);

  useEffect(() => {
    if (taskPaneState.comLocId && taskPaneState.criteria) {
      getDocumentClass(taskPaneState.comLocId, taskPaneState.criteria);
    }
  }, [taskPaneState.comLocId, taskPaneState.criteria]);
  useEffect(() => {
    if (
      taskPaneState?.insuredId &&
      taskPaneState.comLocId &&
      (taskPaneState?.criteria === "Policy #" ||
        taskPaneState?.criteria === "Insured" ||
        taskPaneState?.criteria === "Submission #")
    ) {
      if (!taskPaneState?.isSearch)
        getPoliciesDetailsForInsuredData(taskPaneState?.insuredId, -1, taskPaneState.comLocId, false);
      else setTaskPaneState((prev) => ({ ...prev, isSearch: false }));
    }
  }, [taskPaneState?.insuredId]);

  //   useEffect(() => {
  //   if (taskPaneState?.insuredId && taskPaneState.comLocId && filterTypeByCriteriaType === "Type Insured/Policy") {
  //     getPoliciesDetailsForInsuredData(taskPaneState?.insuredId, -1, taskPaneState.comLocId, true);
  //   }
  // }, [taskPaneState?.criteria]);

  //   useEffect(() => {
  //   if (!!taskPaneState?.useFileName) {
  //     setTaskPaneState((prev) => ({ ...prev, docDescription: "", sameAsDocDesc: false  }));
  //   }
  // }, [taskPaneState?.useFileName]);

  useEffect(() => {
    if (taskPaneState.userId && taskPaneState?.compLocId) {
      getUserGroupsForPerson(taskPaneState.userId);
    }
  }, [taskPaneState.userId, taskPaneState?.compLocId]);
  useEffect(() => {
    if (taskPaneState.userGroupId) {
      getQueuesForUserGroup(taskPaneState.userGroupId);
      getPersonUserGroupXRef(taskPaneState.userGroupId, true, false);
      getTaskTypes(taskPaneState.userGroupId);
    } else {
      setQueues([]);
      setUsers([]);
      setTaskTypes([]);
    }
  }, [taskPaneState.userGroupId]);

  useEffect(() => {
    if (taskPaneState?.comLocId && taskPaneState?.userId)
      getCheckList(selectedItemDetailFromGrid?.policyID, false, taskPaneState?.comLocId, true);
  }, [taskPaneState?.comLocId, taskPaneState?.userId, selectedItemDetailFromGrid?.policyID]);

  const getLocationSpecificInfo = async (comLocId, compId, userId = taskPaneState?.userId, criteria = "") => {
    const operation = requests.start("location", [taskPaneState.userId, compId, comLocId]);
    setSelectedGridItem([]);
    setPoliciesDetailsForInsured([]);
    setTaskPaneState((prev) => ({ ...prev, documentClass: "", checklistItem: "" }));
    try {
      // const userId = taskPaneState?.userId;
      // notify("progress");
      setTaskPaneState((prev) => ({
        ...prev,
        criteria: "",
        insuredId: "",
      }));
      const result = await services.getLocationSpecificInfo(
        comLocId,
        compId,
        userId,
        -1,
        comLocId,
        false,
        false,
      );
      if (!requests.current(operation)) return;
      notify("success", "Location Info data fetch successful!");
      // Criteria cascade seam: how many criteria options the selected location yielded.
      trackEvent("bootstrap.getCriteriaList.result", { criteriaCount: result?.criteriaItems?.length ?? 0 });
      setTaskPaneState((prev) => ({
        ...prev,
        ...result,
        criteria: criteria ? criteria : (result?.criteriaItems[0]?.criteriaName ?? ""),
        insuredId: result?.insuredForRecentPoliciesResults[0]?.insuredID ?? "",
        useFileName: result?.chkTask ?? false,
      }));
      // setDocumentType(result?.documentTypesResults || []);
    } catch (e) {
      if (!requests.current(operation)) return;
      notify("error", "Failed to fetch Location Info data");
      console.log(e);
      trackError(e, { seam: "bootstrap.getLocationSpecificInfo" });
      appInsights.trackDependencyData({
        target: process.env.BASE_URL,
        name: "Excel_LocationSpecificInfo_Payload",
        dependencyTypeName: "HTTPS",
        success: false,
        responseCode: e?.status || 500,
        properties: {
          bodyData: {
            comLocId,
            compId,
            userId: taskPaneState.userId,
          },
          error: e,
          userId: taskPaneState.userId,
        },
      });
    } finally {
      requests.finish(operation);
    }
  };

  return (
    <TaskPaneContext.Provider
      value={{
        profileDetails,
        setProfileDetails,
        locationData,
        setLocationData,
        taskPaneState,
        setTaskPaneState,
        policiesDetailsForInsured,
        setPoliciesDetailsForInsured,
        getPoliciesDetailsForInsuredData,
        filterTypeByCriteriaType,
        selectedGridItem,
        setSelectedGridItem,
        selectedItemDetailFromGrid,
        documentType,
        setDocumentType,
        setDocumentClass,
        documentClass,
        userGroups,
        setUserGroups,
        queues,
        setQueues,
        user,
        setUsers,
        taskTypes,
        setTaskTypes,
        checkList,
        accessToken,
        priorityList,
        setCheckList,
        getLocationSpecificInfo,
        metadataLoading,
        loading,
        setLoading,
      }}
    >
      {Toaster}
      {open && (
        <AlertPopup
          title={title}
          text={text}
          open={open}
          handleClose={() => {
            setOpen(false);
            setTitle("");
            setText("");
          }}
        />
      )}
      {children}
    </TaskPaneContext.Provider>
  );
};

export const useTaskPane = () => {
  const taskPaneContext = useContext(TaskPaneContext);

  if (!taskPaneContext) {
    throw new Error("hook canot be used outside of the TaskPaneProvider");
  }
  return taskPaneContext;
};
